export default __webpack_public_path__ + "static/media/provider-goal-connect.d84eeab2.png";